import React, {useEffect, useRef, useState} from 'react';
import "./PictureShow.css"
import {ArrowType} from "../tools/ArrowType";
import PictureShowButton from "./PictureShowButton";

const classNames = require('classnames');

export default function PictureShow(props: {
    children?: JSX.Element | Array<JSX.Element>,
    className?: string
}) {

    const [pos, setPos] = useState(0);
    const camera = useRef<HTMLDivElement>(null);
    const film = useRef<HTMLDivElement>(null);
    const [isLeft, setLeft] = useState(true);
    const [isRight, setRight] = useState(false);

    let childCount = 0;
    React.Children.forEach(props.children, () => childCount++);


    function getWidth() {
        let cameraWidth = camera.current!.offsetWidth;
        let filmWidth = film.current!.offsetWidth;
        return [cameraWidth, filmWidth];
    }

    useEffect(() => {

        const [cameraWidth, filmWidth] = getWidth();

        if (pos >= 0) {
            setLeft(true);
        } else {
            setLeft(false);
        }

        if ((filmWidth + pos) <= cameraWidth) {
            setRight(true);
        } else {
            setRight(false)
        }

    }, [pos]);

    function handleRight() {
        const [cameraWidth, filmWidth] = getWidth();

        const step = filmWidth / childCount;
        let newPos = pos - step;
        newPos = Math.min(Math.max(newPos, cameraWidth - filmWidth), 0);
        setPos(newPos);
    }

    function handleLeft() {

        const [cameraWidth, filmWidth] = getWidth();

        const step = filmWidth / childCount;
        let newPos = pos + step;
        newPos = Math.min(Math.max(newPos, cameraWidth - filmWidth), 0);
        setPos(newPos);
    }

    return (
        <div className={classNames("picture-show", props.className)}>
            <div className="picture-show-bg-2"/>
            <div className="picture-show-contents">
                <PictureShowButton disabled={isLeft} onClick={handleLeft}/>
                <PictureShowButton disabled={isRight} onClick={handleRight} arrowType={ArrowType.RIGHT}/>
                <div ref={camera} className="picture-show-camera">
                    <div ref={film} className="picture-show-film" style={{left: pos + "px"}}>
                        {props.children}
                    </div>
                </div>
            </div>
        </div>
    )
}